import Reveal from "@/components/Reveal";
import Tricolor from "@/components/Tricolor";

const Invitation = () => (
  <section id="invito" className="relative mx-auto max-w-5xl px-6 py-28 sm:py-36" data-testid="invitation-section">
    <Reveal>
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#E30613]">L'Invito</p>
      <Tricolor className="mt-4" />
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-6 font-display text-2xl font-semibold uppercase tracking-[0.06em] text-[#232525] sm:text-3xl lg:text-4xl">
        Festeggia <span className="text-[#E30613]">insieme a noi</span>
      </h2>
    </Reveal>
    <Reveal delay={0.2}>
      <div className="mt-12 max-w-3xl border-l-2 border-[#E30613]/60 pl-8 sm:pl-12">
        <div className="space-y-5 text-lg font-light leading-loose">
          <p className="text-[#3A3C3C] first-letter:float-left first-letter:mr-4 first-letter:font-display first-letter:text-7xl first-letter:font-semibold first-letter:leading-[0.8] first-letter:text-[#E30613]">
            Siamo lieti di invitarvi a festeggiare insieme a noi questo grande traguardo: 45 anni di Tecnosystem.
          </p>
          <p className="text-[#3A3C3C]">
            Sarà un'intera giornata dedicata alla scoperta di tutti i nuovi prodotti e delle promozioni dedicate a questa giornata, rivivendo insieme questi lunghi e intensi 45 anni di storia.
          </p>
          <p className="pt-3 text-[#5B5D5D]">
            Abbiamo il piacere, visto che siamo una grande famiglia, di aprire le porte anche alle vostre famiglie.
          </p>
          <p className="text-[#5B5D5D]">
            Ci sarà animazione per i vostri bambini e un buffet per intrattenervi tra una visita e l'altra.
          </p>
        </div>
        <p className="mt-10 font-display text-xl font-semibold uppercase tracking-[0.08em] text-[#232525]">La famiglia Tecnosystem</p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.25em] text-[#A9ABA9]">Tecnosystem SRL · dal 1981</p>
      </div>
    </Reveal>
  </section>
);

export default Invitation;
